import metaModel from '~/shared/src/utilities/metaModel';
import Reference, {ReferenceAttributesSettable} from '~/shared/src/ci/Reference';

import {DATA_DELETE_REFERENCE} from '~/frontend/src/constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import {setElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * deleteReference Action
 *
 * @memberOf! Actions
 * @param {string} dataContext
 * @param {number} referenceId
 * @param {boolean} [deletePhysically=true]
 * @param {string[]} [additionalElusiveDataContexts=[]]
 * @param {boolean} [deleteProperties=false]
 *
 * @return {DeleteReferenceAction}
 */
const deleteReference = ( dataContext : string, referenceId : number, deletePhysically : boolean = true, additionalElusiveDataContexts : string[] = [], deleteProperties : boolean = false ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: DATA_DELETE_REFERENCE,
        dataContext,
        referenceId,
        deletePhysically,
        additionalElusiveDataContexts,
        deleteProperties
    } );

    let reference : Reference = global.data[ dataContext ]?.references[ referenceId ];

    if ( reference ) {

        // set status of existing references
        if ( reference.id > 0 ) {
            const historyStatusId                          = metaModel[ reference.schema ].getStatus( 'history' )!.id,
                  deletedStatusId                          = metaModel[ reference.schema ].getStatus( 'deleted' )!.id,
                  statusId                                 = deletePhysically ? deletedStatusId : historyStatusId,
                  attributes : ReferenceAttributesSettable = {
                      statusId
                  }

            if ( deleteProperties ) {
                if ( reference.properties.size ) {
                    attributes.properties = {};
                    for ( const propertyTypeId of reference.properties.keys() ) {
                        attributes.properties![ String( propertyTypeId ) ] = {
                            statusId
                        };
                    }
                }

                if ( reference.enumProperties.size ) {
                    attributes.enumProperties = {};

                    for ( const enumProperty of reference.enumProperties.entries() ) {
                        const propertyTypeIdString = String( enumProperty[ 0 ] );

                        attributes.enumProperties![ propertyTypeIdString ] = {
                            properties: {}
                        };

                        for ( const property of enumProperty[ 1 ].properties.values() ) {
                            attributes.enumProperties![ propertyTypeIdString ].properties![ property.stringKey ] = {
                                statusId
                            };
                        }
                    }
                }
            }

            reference = reference.reset().clone( attributes );
        }

        // delete newly added references
        else {
            global.data[ dataContext ].references[ referenceId ].delete();
        }

        // update ElusiveData
        additionalElusiveDataContexts.unshift( dataContext );
        for ( const elusiveDataContext of additionalElusiveDataContexts ) {
            const elusiveData    = getState().elusiveData?.[ elusiveDataContext ],
                  newElusiveData = {
                      ...elusiveData,
                      data: {
                          ...elusiveData?.data,
                          items     : {
                              ...elusiveData?.data?.items
                          },
                          references: {
                              ...elusiveData?.data?.references
                          }
                      }
                  };

            if ( reference.srcItem ) {
                newElusiveData.data.items[ reference.srcItemId ] = ( elusiveData?.data?.items?.[ reference.srcItemId ] ?? 0 ) + 1;
            }
            else {
                delete newElusiveData.data.items[ reference.srcItemId ];
            }
            if ( reference.destItem ) {
                newElusiveData.data.items[ reference.destItemId ] = ( elusiveData?.data?.items?.[ reference.destItemId ] ?? 0 ) + 1;
            }
            else {
                delete newElusiveData.data.items[ reference.destItemId ];
            }
            if ( reference.id > 0 ) {
                newElusiveData.data.references[ reference.id ] = ( elusiveData?.data?.references?.[ reference.id ] ?? 0 ) + 1;
            }
            else {
                delete newElusiveData.data.references[ reference.id ];
            }

            dispatch( setElusiveData( elusiveDataContext, newElusiveData ) );
        }
    }
}
export type DeleteReference = typeof deleteReference;

export default deleteReference;
